import type { ReactNode } from 'react';
import { useCapabilities } from '../../lib/capabilities';
import { PlanTeaser } from '../ui/PlanTeaser';

// FlagGate (P02 §6) — renders children only when a feature is ON. When LOCKED it
// renders the teaser (default: PlanTeaser for the feature); when OFF it renders
// the `off` fallback (default nothing). Before the capability document hydrates
// it renders `off` — never flashes locked UI (capabilities are part of app boot).
export interface FlagGateProps {
  feature: string;
  children: ReactNode;
  teaser?: ReactNode;
  off?: ReactNode;
  name?: string;
}

export function FlagGate({ feature, children, teaser, off = null, name }: FlagGateProps): JSX.Element {
  const { featureState, isHydrated } = useCapabilities();

  if (!isHydrated) return <>{off}</>;

  const { state } = featureState(feature);
  if (state === 'on') return <>{children}</>;
  if (state === 'locked') return <>{teaser ?? <PlanTeaser feature={feature} {...(name ? { name } : {})} />}</>;
  return <>{off}</>;
}
